export default __webpack_public_path__ + "locales/it/MainBar.json?hash=1559fd1213b9e4f80acb8dd056628b0d";